exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".step-div[data-v-6065bc46]{text-align:left;background-color:#fff;margin:0 auto;line-height:50px;font-size:0}.step-div .ant-tag[data-v-6065bc46]{font-size:14px;margin:20px}.step-div .ant-radio-group[data-v-6065bc46]{width:90%}.step-div .ant-radio-button-wrapper[data-v-6065bc46]{border-radius:4px!important}.span-div[data-v-6065bc46]{width:10%;display:inline-block;text-align:right;font-size:14px;line-height:64px;vertical-align:top}", ""]);

// exports
